import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Импорт переводов из существующего файла
import { translations } from './utils/translations';

// Преобразование существующих переводов в формат i18next
const resources = {
  en: {
    translation: translations.en
  },
  ru: {
    translation: translations.ru
  },
  fr: {
    translation: translations.fr
  },
  es: {
    translation: translations.es
  },
  de: {
    translation: translations.de
  }
};

// Инициализируем i18n, но не устанавливаем язык сразу
// Это делается в LanguageContext для лучшей синхронизации
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Язык по умолчанию, будет изменен LanguageContext
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // не нужно экранировать для React
    },
    react: {
      useSuspense: false // Отключаем Suspense для предотвращения мерцания
    }
  });

export default i18n; 